import PriceMap from '../charts/PriceMap';

interface PriceMapTabProps {
  t: (key: string) => string;
}

const PriceMapTab = ({ t }: PriceMapTabProps) => {
  return (
    <div className="tab price-map-tab flex flex-col gap-10 px-2 pt-8 md:px-8 md:pt-12 lg:pt-14">
      <PriceMap t={t} />
    </div>
  );
};

export default PriceMapTab;
